import cloudIcon from "@assets/images/cloud.svg";
import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import { Button, Paper } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/styles";
import HeadColored from "@saleor/components/HeadColored";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { FC } from "react";

const useStyle = makeStyles(
  theme => ({
    root: {
      height: "100%",
      marginBottom: "200px"
    },
    mainPanel: {
      background: "transparent"
    },
    headTextLogo: {
      margin: "120px 0 104px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    },
    paper: {
      width: "420px",
      padding: "43px 32px 32px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.6rem"
    },
    cloudIcon: {
      width: 56,
      height: 56,
      marginBottom: "2.7rem"
    },
    des: {
      marginBottom: "1.6rem",
      textAlign: "center"
    },
    errorcode: {
      color: theme.palette.grey[500],
      marginBottom: "1.6rem"
    },
    btnSubmit: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",

      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    }
  }),
  { name: "OrderProcessingFailedView" }
);

interface OrderProcessingFailedProps {
  onFailed: () => void;
  errorCode?: string;
  styles?: ClassNameMap<"container" | "root" | "footer">;
}

const OrderProcessingFailed: FC<OrderProcessingFailedProps> = ({
  onFailed,
  errorCode,
  styles
}) => {
  const classes = useStyle();

  return (
    <>
      <HeadColored fixedTop />
      <div className={styles.container}>
        <div className={classes.root}>
          <div className={classes.mainPanel}>
            <div className={classes.headTextLogo}>
              <div className={classes.text}>
                <img src={SCGP_Color} alt={"logo_scg"} />
              </div>
              <div className={classes.logo}>
                <img src={EOrderingLogo} alt={"logo"} />
              </div>
            </div>
            <Paper className={classes.paper}>
              <img src={cloudIcon} alt="" className={classes.cloudIcon} />
              <MyTypography variant="h6" className={classes.caption}>
                ไม่สามารถทำรายการได้
              </MyTypography>
              <MyTypography variant="body2" className={classes.des}>
                เนื่องจากไม่สามารถติดต่อระบบได้ในขณะนี้
                <br />
                กรุณาลองใหม่อีกครั้ง
              </MyTypography>
              <MyTypography variant="body3" className={classes.errorcode}>
                Error code: {errorCode}
              </MyTypography>
              <Button onClick={onFailed} className={classes.btnSubmit}>
                <MyTypography variant="body1">ตกลง</MyTypography>
              </Button>
            </Paper>
          </div>
        </div>
        <footer className={styles.footer}>
          <MyTypography variant="body3" style={{ color: "#333333" }}>
            COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
          </MyTypography>
        </footer>
      </div>
    </>
  );
};

export default OrderProcessingFailed;
